import { SxProps, Theme } from '@mui/material';

export const StatusPageStyles: SxProps<Theme> = (theme) => ({
    a: {
        fontWeight: '700',
        textDecoration: 'none',
        color: theme.palette.primary.main,
    },
});
